import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import {
  organizationsTeamsListOptions,
  organizationsTeamsListQueryKey
} from 'src/api/main'

import type { OrgUnit } from '../types'

/** All teams (branches, departments, sections) for a workspace. */
export const useOrganizationTeams = (
  workspaceId: number,
  enabled: boolean = true
) => {
  const query = useQuery({
    ...organizationsTeamsListOptions({
      query: { organization: workspaceId, per_page: 500 }
    }),
    enabled: enabled && Number.isFinite(workspaceId)
  })

  const teams = useMemo<OrgUnit[]>(
    () => query.data?.results ?? [],
    [query.data]
  )

  return { ...query, teams }
}

export const organizationTeamsQueryKey = (workspaceId: number) =>
  organizationsTeamsListQueryKey({
    query: { organization: workspaceId, per_page: 500 }
  })
